import brandplus from './img/brandplus.jpg';
import kolnaexplorer from './img/kolnaexplorer.jpg';
import reviews from './img/reviews.jpg';
import tours from './img/tours.jpg';

export default [
    {image: brandplus, title:'E-commerse store', tags:'Elementor, Woocommerce, Wordpress', url:'https://dev-brandpus.pantheonsite.io/'},
    {image: kolnaexplorer, title:'Kolna Explorer', tags:'PHP, HTML, CSS, Bootstrap, Javascript', url:'https://kolnaexplorer.com/'},
    {image: reviews, title:'Reviews card', tags:'React.js, Hooks, Json ', url:'https://reviews-card.netlify.app/'},
    {image: tours, title:'Tours blog', tags:'React.js, Hooks, Json', url:'https://tours-card.netlify.app/'} 
]